import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import styled, { ThemeProvider, useTheme } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledMobilePanel = styled.div.withConfig({
  displayName: "MobilePanelFooter__StyledMobilePanel",
  componentId: "gjvdln-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    borderTop: `1px solid ${theme.color['border-core-pressed']}`
  };
});
export default function MobilePanelFooter(props) {
  const theme = useTheme();
  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: theme,
    children: /*#__PURE__*/_jsx(StyledMobilePanel, {
      children: /*#__PURE__*/_jsx(DialogFooter, Object.assign({}, props, {
        paddingInlineStart: "600"
      }))
    })
  });
}